export default {
  cartItem: {
    productId: -1,
    product: null,
    quantity: 0,
    subTotal: 0,
    subTotalJpy: `¥0`,
  },
};
